// Handles keyboard navigation for menu without modifying the original component
(function() {
  // Wait for DOM content and menu to be loaded
  function init() {
    if (!document.querySelector('.tmenu_initialized')) {
      setTimeout(init, 100); // Keep checking until menu is loaded
      return;
    }
    initKeyboardNav();
  }

  function initKeyboardNav() {
    // Pre-render all submenus by simulating mouseover
    preRenderSubmenus();

    // Add keyboard event listeners
    document.addEventListener('keydown', handleKeyboardNavigation);
    document.addEventListener('focusin', handleFocusIn);
    
    // Add ARIA attributes for accessibility
    addAriaAttributes();

    // Add focusout listeners so submenus close when you tab away
    addFocusOutListeners();
  }

  function handleFocusIn(e) {
    const focusedElement = e.target;
    if (focusedElement.classList.contains('tmenu_item_link')) {
      const menuItem = focusedElement.closest('.tmenu_item');
      if (menuItem && menuItem.querySelector('.tmenu_submenu')) {
        openSubmenu(menuItem);
      }
    }
  }

  function addFocusOutListeners() {
  // Select all items (both root and nested)
  const allMenuItems = document.querySelectorAll('.tmenu_item');

  allMenuItems.forEach(item => {
    item.addEventListener('focusout', (e) => {
      // If focus has left this entire item (and its subtree),
      // close the submenu if it's open.
      if (!item.contains(e.relatedTarget)) {
        closeSubmenu(item);
      }
    });
  });
  }

  function preRenderSubmenus() {
    const rootItems = document.querySelectorAll('.tmenu_item--root');
    rootItems.forEach(item => {
      // Simulate mouseover to trigger submenu rendering
      const event = new MouseEvent('mouseenter', {
        bubbles: true,
        cancelable: true
      });
      item.dispatchEvent(event);
      
      // Immediately hide submenu after rendering
      setTimeout(() => {
        const leaveEvent = new MouseEvent('mouseleave', {
          bubbles: true,
          cancelable: true
        });
        item.dispatchEvent(leaveEvent);
      }, 100);
    });
  }

  function addAriaAttributes() {
    // Add ARIA attributes to menu elements
    const menu = document.querySelector('.main-nav');
    menu.setAttribute('role', 'menubar');

    const menuItems = document.querySelectorAll('.tmenu_item');
    menuItems.forEach(item => {
      const link = item.querySelector('.tmenu_item_link');
      const submenu = item.querySelector('.tmenu_submenu');
      
      if (link) {
        link.setAttribute('role', 'menuitem');
        if (submenu) {
          link.setAttribute('aria-haspopup', 'true');
          link.setAttribute('aria-expanded', 'false');
        }
      }
      
      if (submenu) {
        submenu.setAttribute('role', 'menu');
        const subItems = submenu.querySelectorAll('.tmenu_item_link');
        subItems.forEach(subItem => {
          subItem.setAttribute('role', 'menuitem');
        });
      }
    });
  }

  function handleKeyboardNavigation(e) {
    const activeElement = document.activeElement;
    
    // Only handle if we're on a menu item
    if (!activeElement.closest('.tmenu_item')) {
      return;
    }

    const currentItem = activeElement.closest('.tmenu_item');
    const submenu = currentItem.querySelector('.tmenu_submenu');
    const parentMenu = currentItem.closest('.tmenu_submenu');
    const isRootItem = currentItem.classList.contains('tmenu_item--root');
    
    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (isRootItem && submenu) {
          // If we're on a root item with submenu, move to first submenu item
          const firstSubItem = submenu.querySelector('.tmenu_item_link');
          if (firstSubItem) {
            openSubmenu(currentItem);
            firstSubItem.focus();
            return;
          }
        }
        
        // Try to move to the next sibling in the current menu level
        const nextItem = currentItem.nextElementSibling;
        if (nextItem) {
          closeSubmenu(currentItem); // Close current submenu before moving
          const link = nextItem.querySelector('.tmenu_item_link');
          if (link) {
            link.focus();
            return;
          }
        }
        
        // If no next sibling and we're in a submenu, try parent's next sibling
        if (parentMenu) {
          const parentMenuItem = parentMenu.closest('.tmenu_item');
          const parentNextItem = parentMenuItem.nextElementSibling;
          if (parentNextItem) {
            closeSubmenu(parentMenuItem); // Close parent's submenu before moving
            const link = parentNextItem.querySelector('.tmenu_item_link');
            if (link) {
              link.focus();
            }
          }
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (parentMenu) {
          // Move to previous item in current menu
          const prevItem = currentItem.previousElementSibling;
          if (prevItem) {
            closeSubmenu(currentItem); // Close current submenu before moving
            const link = prevItem.querySelector('.tmenu_item_link');
            if (link) {
              link.focus();
            }
          } else {
            // Move back to parent menu item if at top
            const parentItem = parentMenu.closest('.tmenu_item');
            if (parentItem) {
              closeSubmenu(currentItem);
              const parentLink = parentItem.querySelector('.tmenu_item_link');
              if (parentLink) {
                parentLink.focus();
              }
            }
          }
        } else {
          // At root level, move to previous root item
          const prevRoot = currentItem.previousElementSibling;
          if (prevRoot) {
            closeSubmenu(currentItem); // Close current submenu before moving
            const link = prevRoot.querySelector('.tmenu_item_link');
            if (link) {
              link.focus();
            }
          }
        }
        break;

      case 'ArrowRight':
        e.preventDefault();
        if (submenu) {
          // Open submenu and move to first item
          const firstSubItem = submenu.querySelector('.tmenu_item_link');
          if (firstSubItem) {
            openSubmenu(currentItem);
            firstSubItem.focus();
          }
        } else {
          // Move to next root menu item
          const nextRoot = currentItem.nextElementSibling;
          if (nextRoot) {
            closeSubmenu(currentItem); // Close current submenu before moving
            const link = nextRoot.querySelector('.tmenu_item_link');
            if (link) {
              link.focus();
            }
          }
        }
        break;

      case 'ArrowLeft':
        e.preventDefault();
        if (parentMenu) {
          // Close current submenu and move back to parent
          const parentItem = parentMenu.closest('.tmenu_item');
          if (parentItem) {
            closeSubmenu(currentItem);
            const parentLink = parentItem.querySelector('.tmenu_item_link');
            if (parentLink) {
              parentLink.focus();
            }
          }
        } else {
          // Move to previous root menu item
          const prevRoot = currentItem.previousElementSibling;
          if (prevRoot) {
            closeSubmenu(currentItem); // Close current submenu before moving
            const link = prevRoot.querySelector('.tmenu_item_link');
            if (link) {
              link.focus();
            }
          }
        }
        break;

      case 'Escape':
        e.preventDefault();
        // Close all submenus up to root
        let menuItem = currentItem;
        while (menuItem) {
          closeSubmenu(menuItem);
          menuItem = menuItem.parentElement.closest('.tmenu_item');
        }
        // Focus the root menu item
        const rootItem = currentItem.closest('.tmenu_nav').querySelector('.tmenu_item--root .tmenu_item_link');
        if (rootItem) {
          rootItem.focus();
        }
        break;

      case 'Enter':
      case ' ':
        // Activate menu items on Enter/Space
        if (activeElement.getAttribute('href') && activeElement.getAttribute('href') !== 'javascript:;') {
          return; // Let the browser handle actual links
        }
        e.preventDefault();
        if (submenu) {
          openSubmenu(currentItem);
          const firstSubItem = submenu.querySelector('.tmenu_item_link');
          if (firstSubItem) {
            firstSubItem.focus();
          }
        }
        break;
    }
  }

  function openSubmenu(item) {
    // Simulate mouse enter to open submenu
    item.classList.add('tmenu_item_active');
    const link = item.querySelector('.tmenu_item_link');
    if (link) {
      link.setAttribute('aria-expanded', 'true');
    }
  }

  function closeSubmenu(item) {
    // Simulate mouse leave to close submenu
    item.classList.remove('tmenu_item_active');
    const link = item.querySelector('.tmenu_item_link');
    if (link) {
      link.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('focusin', (e) => {
    // Find all menu items currently marked as "active"
    const openItems = document.querySelectorAll('.tmenu_item_active');
  
    openItems.forEach(item => {
      // If this open item doesn't contain the newly focused element,
      // close it so only the relevant submenu remains open.
      if (!item.contains(e.target)) {
        closeSubmenu(item);
      }
    });
  });

  // Start initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
